import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import glassesService from "../../../services/glasses.service";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

const initialValues = {
  name: "",
  colorId: undefined,
  colorValue: "",
  price: 0,
  currencyId: undefined,
  currencyPrice: undefined,
  discount: 0,
  isActive: true,
  isUnavailable: false,
  isMain: false,
  fixCost: false,
  fixDiscount: false,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  colorId: yupSchema.colorId,
  price: yupSchema.priceMin,
  color: yupSchema.optionalColorHex,

  // image
  // price
  // modelObject
  // frontImage
  // sideImage
  // threeQuarterImage
  // modelImage
  // isActive

  // TODO: schema
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra, parent }) {
    const { initials } = useSelector((state) => state.app);

    const errorHandler = useErrorHandler();

  const form = useMemo(
    () => [
      {
        _type: "container",
        name: "col1",
        _wrapper: (props) => <Grid item sm={7} md={6} xs={12} {...props} />,
        form: [
          {
            _type: "textField",
            name: "name",
            label: "نام",
            autoFocus: true,
          },
          {
              _type: "autocomplete",
              _empty: undefined,
              name: "lensProperty",
              multiple: true,
              options: initials?.enums?.lensProperty || [],
              label: "جنس عدسی",
              disableClearable: true,
              valueSelector: "value",
              labelSelector: "title",
          },
          {
            _type: "autocomplete",
            _empty: undefined,
            name: "colorId",
            options: extra?.colors || [],
            label: "رنگ",
            disableClearable: true,
            valueSelector: "id",
            labelSelector: "name",
          },
          {
            _type: "textField",
            name: "colorValue",
            label: "کد رنگ",
          },
          {
            _type: "filePicker",
            name: "image",
            label: "تصویر رنگ",
            isImage: true,
          },
          {
            _type: "textField",
            name: "lensColor",
            label: "رنگ عدسی",
          },
          {
            _type: "textField",
            name: "templeColor",
            label: "رنگ دسته",
          },
          {
            _type: "textField",
            name: "price",
            type: "currency",
            label: "قیمت",
            inputProps: {
              min: 0,
            },
          },
          {
            _type: "autocomplete",
            _empty: undefined,
            name: "currencyId",
            options: extra?.currencies || [],
            label: "ارز",
            valueSelector: "id",
            labelSelector: (option) =>
              option.code ? `${option.name} (${option.code})` : option.name,
          },
          {
            _type: "textField",
            name: "currencyPrice",
            type: "number",
            label: "قیمت ارزی",
            inputProps: {
              min: 0,
            },
          },
          {
            _type: "textField",
            name: "discount",
            type: "number",
            label: "تخفیف٪",
            inputProps: {
              min: 0,
              max: 100,
            },
          },
        ],
      },
      {
        _type: "container",
        name: "col2",
        _wrapper: (props) => <Grid item sm={5} md={6} xs={12} {...props} />,
        form: [
          // {
          //   _type: "filePicker",
          //   name: "modelObject",
          //   label: "مدل سه بعدی",
          //   accept: ".sfa",
          // },
          {
            _type: "filePicker",
            name: "frontImage",
            label: "تصویر مقابل",
            isImage: true,
          },
          {
            _type: "filePicker",
            name: "sideImage",
            label: "تصویر از بغل",
            isImage: true,
          },
          {
            _type: "filePicker",
            name: "threeQuarterImage",
            label: "تصویر سه‌رخ",
            isImage: true,
          },
          {
            _type: "filePicker",
            name: "modelImage",
            label: "تصویر مدل",
            isImage: true,
          },
          {
            _type: "switch",
            name: "isActive",
            label: "فعال",
          },
          {
            _type: "switch",
            name: "isUnavailable",
            label: "ناموجود",
          },
          {
            _type: "switch",
            name: "isMain",
            label: "اصلی",
          },
          {
            _type: "switch",
            name: "fixCost",
            label: "قیمت ثابت",
          },
          {
            _type: "switch",
            name: "fixDiscount",
            label: "تخفیف ثابت",
          },
        ],
      },
    ],
    [extra]
    // [extra, data?.id]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await glassesService.editGlassesColor(data.id, model);
    } else {
      op = await glassesService.createGlassesColor({
        ...model,
        glassesId: parent.id,
      });
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "رنگ عینک",
        data: {
            ...data,
            lensProperty: data?.lensProperty ? JSON.parse(data?.lensProperty) : []
        },
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
  // return (
  //   <Loading isLoading={waiting} overlay>
  //     <DialogTitle onClose={() => close()}>
  //       {id ? "ویرایش عینک" : "ایجاد عینک"}
  //     </DialogTitle>
  //     <Divider />
  //     <Formik
  //       initialValues={id ? initialValues : emptyValues}
  //       onSubmit={handleSubmit}
  //       validationSchema={formSchema}
  //     >
  //       {({ isSubmitting, values }) => (
  //         <Form autoComplete="off">
  //           <DialogContent>
  //             <FTextField name="name" label="نام" autoFocus />
  //             <FTextField name="summery" label="خلاصه توضیحات"  />
  //             <FTextField name="description" label="توضیحات" />
  //             <FTextField name="weight" label="وزن" type="number" />
  //           </DialogContent>
  //           <DialogActions>
  //             <Button onClick={close} color="primary" disabled={isSubmitting}>
  //               لغو
  //             </Button>
  //             <Button
  //               type="submit"
  //               disabled={isSubmitting}
  //               variant="contained"
  //               color="primary"
  //             >
  //               {id ? "ذخیره" : "ایجاد"}
  //             </Button>
  //           </DialogActions>
  //         </Form>
  //       )}
  //     </Formik>
  //   </Loading>
  // );
}
